export const queryKeys = {
  vendor: {
    settings: () => ['vendor', 'settings'],
  },
  orders: {
    comments: (orderId) => ['orders', String(orderId), 'comments'],
    phases: (orderId) => ['orders', String(orderId), 'phases'],
  },
  phases: {
    templates: () => ['phases', 'templates'],
  },
  notifications: {
    unreadCount: () => ['notifications', 'unread-count'],
    list: (perPage = 10, page = 1) => ['notifications', 'list', perPage, page],
  },
};
